import { endOfDay, startOfDay } from 'date-fns'
import { FormProvider, useForm } from 'react-hook-form'

import { DriverLocationTrackingReportInputDtoInput, DriverUserTypeFilter } from 'generated/graphql'

import FilterCriteriaForm from './FilterCriteriaForm'

const defaultFilter: DriverLocationTrackingReportInputDtoInput = {
  userType: DriverUserTypeFilter.AllJobs,
}

interface IProps {
  onViewReport: (filter: DriverLocationTrackingReportInputDtoInput) => void
  onClear: () => void
}

const FilterCriteria = ({ onViewReport, onClear }: IProps) => {
  const methods = useForm<DriverLocationTrackingReportInputDtoInput>({
    shouldUnregister: true,
    defaultValues: defaultFilter,
  })

  const { handleSubmit, reset, setError } = methods

  const handleClearAll = () => {
    reset(defaultFilter)
    onClear()
  }

  const handleViewReport = handleSubmit((formData) => {
    let invalid = false
    if (!formData.start) {
      setError('start', { message: 'Required' })
      invalid = true
    }
    if (!formData.end) {
      setError('end', { message: 'Required' })
      invalid = true
    }
    if (invalid) return

    onViewReport({
      start: startOfDay(formData.start as unknown as Date),
      end: endOfDay(formData.end as unknown as Date),
      userType: formData.userType ?? DriverUserTypeFilter.AllJobs,
    })
  })

  return (
    <FormProvider {...methods}>
      <FilterCriteriaForm onClearAll={handleClearAll} onViewReport={handleViewReport} />
    </FormProvider>
  )
}

export default FilterCriteria
